import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Page } from '@shared/models/page-sort/page';
import { Pageable } from '@shared/models/page-sort/pageable';
import { SearchCriteriaDto } from '@shared/models/search-criteria-dto';
import { DisclosedDocumentDto } from '@shared/models/disclosed-document-dto';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class SearchService {
    readonly criteria: string = 'criteria';
    readonly reference: string = 'reference';

    constructor(private readonly http: HttpClient) {
    }
    // By default, the search is by criteria otherwise it is by reference
    searchBy(searchType: string, searchCriteria: SearchCriteriaDto, pageable: Pageable): Observable<Page<DisclosedDocumentDto>> {
        const searchTypeSegment = searchType === this.criteria ? this.criteria : this.reference

        let params = new HttpParams();
        for(const key in searchCriteria) {
            if(searchCriteria[key]) {
                params = params.append(key, searchCriteria[key]);
            }
        }
        // Add paging parameters
        params = params.append('page', pageable.page.toString());
        params = params.append('size', pageable.size.toString());
        // Add sorting parameter
        params = params.append('sort', pageable.sort.by + ',' + (pageable.sort.ascending ? 'ASC' : 'DESC'));
        return this.http.get<Page<DisclosedDocumentDto>>('api/portal/search/' + searchTypeSegment, { params });
    }

    getAutocompleteKeywords(keyword) {
        return this.http.get('api/portal/search/autocomplete/keyword/?input=' + keyword);
    }

    getAutocompleteReferences(reference) {
        return this.http.get('api/portal/search/autocomplete/reference/?input=' + reference);
    }

    loadPublishedDocument(publishedDocumentId: number): Observable<DisclosedDocumentDto> {
        return this.http.get<DisclosedDocumentDto>('api/portal/search/' + publishedDocumentId);
    }
}
